import type { ReactNode } from 'react';
import { useFieldAnnotations } from '../data/fieldAnnotations';

interface FieldProps {
  /** The contract field this value came from, e.g. `businessStatement` or `scope.ref`. */
  name: string;
  children: ReactNode;
}

/**
 * Labels a rendered value with the contract field behind it, when the field-keys overlay is on.
 *
 * Returns its children untouched when the overlay is off — no wrapper element, no layout shift — so
 * the annotated build and the real one are the same build rather than two that can drift.
 */
export const Field = ({ name, children }: FieldProps) => {
  const annotate = useFieldAnnotations();
  if (!annotate) return <>{children}</>;

  return (
    <span
      data-field={name}
      className="rounded-xs bg-bg-info-subtler outline outline-border-info-subtle"
    >
      <span className="pr-1 font-mono text-[9px] tracking-normal text-text-info normal-case">
        {name}
      </span>
      {children}
    </span>
  );
};
